// 导入封装的方法
import {
  post,
  postform
} from '../http'

const Universal = {
  proposalfile (params) {
    console.log(params)
    return postform('/attachment/uploadFile', params, { 'content-type': 'application/x-www-form-urlencoded' })
  },
  dictionaryPubkvs (params) {
    return post('/dictionary/pubkvs?', params)
  },
  massesAdd (params) {
    return post('/masses/add?', params)
  },
  commentAdd (params) {
    return post('/comment/savePublic?', params)
  },

}
export default Universal
